import React from 'react';
import { UserProfile } from '@/shared/types';
import {
  SplitHeroHeader,
  CenteredClassicHeader,
  DarkHeader,
  MinimalGridHeader,
  HeroBlockHeader,
  GradientTopHeader,
  ArtisticHeroHeader,
  DefaultHeader
} from '@/features/templates/components/CorporateSuite/components/HeaderComponents';

interface HeaderRendererProps {
  profile: UserProfile;
  title: string;
  type: string;
  metaData: { label: string; value: string }[];
  config: any;
  LogoImage: React.FC<{ size: 'sm' | 'md' | 'lg' | 'xl'; className?: string; light?: boolean }>;
}

export const renderHeader = (props: HeaderRendererProps): React.ReactNode => {
  const { config } = props;

  switch (config.header) {
    case 'sidebar-left':
    case 'sidebar-right':
    case 'dark-sidebar':
      return null; // Handled in layout

    case 'split-hero':
    case 'split-hero-navy':
      return <SplitHeroHeader {...props} />;

    case 'centered-classic':
    case 'classic-row':
    case 'classic-finance':
      return <CenteredClassicHeader {...props} />;

    case 'dark-header':
      return <DarkHeader {...props} />;

    case 'minimal-grid':
      return <MinimalGridHeader {...props} />;

    case 'hero-block':
      return <HeroBlockHeader {...props} />;

    case 'gradient-top':
      return <GradientTopHeader {...props} />;

    case 'artistic-hero':
      return <ArtisticHeroHeader {...props} />;

    default: // Default modern layout
      return <DefaultHeader {...props} />;
  }
};